import { inject, Injectable } from '@angular/core';
import { map } from 'rxjs';
import { CreateProductDTO, GetByProductCodeDTO, ProductDTO, ProductLibraryFindResponseDTO } from '../interface/product-library.entity';
import { APIRequestOptions, APIRequestResources, APIResponse, ApiService } from '../../../core';

@Injectable({
  providedIn: 'root'
})
export class ProductLibrarayService {
  private readonly apiService = inject(ApiService);

  createProduct(product: CreateProductDTO) {
          return this.apiService.POST<APIResponse<any>>(
              APIRequestResources.ProductLibrarayService,
              product,
              {
                  endpoint: ''
              }
          )
      }

  getAllProducts(params?: Record<string, any>) {
    const options: APIRequestOptions = {
      endpoint: '',
      params: params || {}
    };

    return this.apiService.GET<ProductLibraryFindResponseDTO>(
      APIRequestResources.ProductLibrarayService,
      options
    );
  }

  getMachines() {
    return this.apiService.GET<any>(
        APIRequestResources.MachineService,
        { endpoint: '' }
    );
  }

  getFinishings() {
    return this.apiService.GET<any>(
        APIRequestResources.FinishingService,
        { endpoint: '' }
    );
  }

  uploadproductExcel(file: File) {
    const formData = new FormData();
    formData.append('file', file);

    return this.apiService.POST<any>(
        APIRequestResources.ProductLibrarayService,
          formData,
          {
              endpoint: 'import'
          }
    );
  }

  getProductById(id: string) {
    const options: APIRequestOptions = {
      endpoint: `${id}`
    };

    return this.apiService.GET<ProductDTO>(
      APIRequestResources.ProductLibrarayService,
      options
    );
  }

  updateProduct(productCode: string, payload: CreateProductDTO) {
    const options: APIRequestOptions = {
      endpoint: `${productCode}`
    };

    return this.apiService.PATCH<APIResponse<any>>(
      APIRequestResources.ProductLibrarayService,
      payload,
      options
    );
  }

  getAllCustomers() {
    return this.apiService.GET<any>(
      APIRequestResources.CustomerService,
      { endpoint: '' }
    ).pipe(
      map(response => {
        if (response && response.data && Array.isArray(response.data.data)) {
          return response.data.data.map((c: any) => ({
            id: c.customerId,
            customerName: c.customerName || ''
          })) as { id: number; customerName: string }[];
        }
        return [] as { id: number; customerName: string }[];
      })
    );
  }

}
